import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'minuteToHour'
})
export class MinuteToHourPipe implements PipeTransform {
  transform(value: number) {
    let hours = Math.floor(value / 60);
    let minutes = Math.floor(value % 60);
    let result = '';
    result += hours > 0 ? hours + 'H ' : '';
    result += minutes > 0 ? minutes + 'M' : '';
    return  result;
  }
}
